import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Help = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="help icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.55126 16.9262C8.47658 16.3909 7.60174 15.5143 7.06869 14.4384L3.4358 14.7746C4.32204 17.5121 6.48431 19.6753 9.2212 20.5628L9.55126 16.9262ZM7.07816 9.54261C7.61236 8.47476 8.48386 7.60499 9.55299 7.07298L9.2219 3.43695C6.48726 4.32351 4.3262 6.48362 3.43832 9.21767L7.07816 9.54261ZM14.447 7.07298C15.5161 7.60499 16.3876 8.47476 16.9218 9.54261L20.5617 9.21767C19.6738 6.48362 17.5127 4.32351 14.7781 3.43695L14.447 7.07298ZM16.9313 14.4384C16.3983 15.5143 15.5234 16.3909 14.4487 16.9262L14.7788 20.5628C17.5157 19.6753 19.678 17.5121 20.5642 14.7746L16.9313 14.4384ZM12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z"
    />
  </svg>
)
